import { render } from "./PerformanceChart4.vue?vue&type=template&id=f76c484c&ts=true"
import script from "./PerformanceChart4.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart4.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__